import Fuse from 'fuse.js';

interface DropdownOption {
  label: string;
  value: string;
}

export const findFuzzyMatch = (
  searchedValue: string | null | undefined,
  options: DropdownOption[]
): any => {
  if (!searchedValue || !options.length) return undefined;

  const fuseOptions = {
    keys: ['label'],
    threshold: 0.4,
    ignoreLocation: true,
  };

  const fuse = new Fuse(options, fuseOptions);
  const results = fuse.search(searchedValue);

  return results.length > 0 ? results[0].item : undefined;
};